import { render, staticRenderFns } from "./RoomBoard.vue?vue&type=template&id=2ce2358c&scoped=true&"
import script from "./RoomBoard.vue?vue&type=script&lang=js&"
export * from "./RoomBoard.vue?vue&type=script&lang=js&"
import style0 from "./RoomBoard.vue?vue&type=style&index=0&id=2ce2358c&lang=scss&scoped=true&"
import style1 from "./RoomBoard.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce2358c",
  null
  
)

export default component.exports